import React from 'react';

import { Box, CircularProgress } from '@myn/mui';

const EditModalLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flexBasis: '100% !important',
        height: '80vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default EditModalLoader;
